import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { HttpResponse, Job } from "@/types";

export function useGetJob() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["job", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}`;
      const res = await httpClient.get<Job, HttpResponse<Job>>(path);
      return res.data;
    },
  });
}
